export default {
  inputRange: {
    '& input[type=range]': {
      height: '25px',
      margin: '10px 0',
      width: '100%',
    }
  },
  starPointsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    font: "16px 'Open Sans',sans-serif",
    color: '#cbcaca',
  },
  starPointsSelection:{
    display: 'flex',
    justifyContent: 'flex-end',
    maxWidth: '200px',
    marginLeft: 'auto',
    marginTop: '20px',
    '& button': {
      maxWidth: '100px',
      '& span': {
        display: 'block',
        padding: '5px 0',
      }
    },
  },
  starPoints: {
    border: '1px solid #cbcaca',
    display: 'flex',
    alignItems: 'center',
    font: "14px 'Open Sans',sans-serif",
    margin: '5px 0',
  },
  starPointsApply: {
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
  },
  blue: {
    accentColor: '#2972B8'
  },
  silver: {
    accentColor: '#A09F9B'
  },
  gold: {
    accentColor: '#B2A16B'
  }
};